import { schema } from 'normalizr'
import { createEntitySchemas, normalize, denormalize, makeResponseSchema } from '../../../utils/normalize'

import { peopleType } from '../constants'

export const RESPONSIBLES = peopleType[1]
export const responsiblesSchemas = createEntitySchemas(RESPONSIBLES)

export const COLLABORATORS = peopleType[2]
export const collaboratorsSchemas = createEntitySchemas(COLLABORATORS)

const peopleListSchema = new schema.Array({
  [RESPONSIBLES]: responsiblesSchemas.entity,
  [COLLABORATORS]: collaboratorsSchemas.entity
}, entity => peopleType[entity.type])
const peopleListResponseSchema = makeResponseSchema(peopleListSchema)

export const peopleSchemas = {
  list: peopleListSchema,
  responseList: peopleListResponseSchema,
  normalizeList: normalize(peopleListSchema),
  normalizeResponseList: normalize(peopleListResponseSchema),
  denormalizeList: denormalize(peopleListSchema)
}
